import React, { useState, createContext, useEffect } from "react";
import config from "../../helpers/config";
import axios from "axios";

export const AllDetailsContext = createContext();

export const UserDetailProvider = (props) => {
  const [userData, setUserData] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [userCompanyData, setUserCompanyData] = useState(null);
  const [userSkill, setUserSkill] = useState(null);
  const [isValueChange, setIsValueChange] = useState(false);
  const [reload, setReload] = useState(false);
  const [allJoinedCompany, setAllJoinedCompany] = useState(null);
  const [loading, setLoading] = useState(null);
  const [allOwnCompany, setAllOwnCompany] = useState(null);
  const [userTopskill, setUserTopskill] = useState(null);

  /* ✅ ADD THIS FUNCTION */
  const fetchUserData = () => {
    setReload((prev) => !prev);
  };

  /* ================= USER PROFILE ================= */
  useEffect(() => {
    axios
      .get(
        `${config.API_URL()}profile/${localStorage.getItem(
          "user_profile_id"
        )}?default_user=${localStorage.getItem("default_user")}`
      )
      .then((res) => {
        setUserData(res?.data?.result?.data);
      })
      .catch(() => {});
  }, [reload]);

  /* ================= COMPANY LIST ================= */
  useEffect(() => {
    axios
      .get(
        `${config.API_URL()}recruiters?default_user=${localStorage.getItem(
          "default_user"
        )}`
      )
      .then((res) => setCompanyData(res?.data?.result?.data))
      .catch(() => {});
  }, []);

  /* ================= USER COMPANY ================= */
  useEffect(() => {
    axios
      .get(
        `${config.API_URL()}company/list?default_user=${localStorage.getItem(
          "default_user"
        )}`
      )
      .then((res) => setUserCompanyData(res?.data?.result?.data))
      .catch(() => {});
  }, []);

  /* ================= USER SKILLS ================= */
  useEffect(() => {
    const formBody = new FormData();
    formBody.append("user_id", localStorage.getItem("user_id"));

    axios({
      method: "post",
      url: `${config.API_URL()}get_selected_skills`,
      data: formBody
    })
      .then((res) => {
        setUserSkill(res?.data?.result?.data);
        setIsValueChange(false);
      })
      .catch(() => {});
  }, [isValueChange]);

  /* ================= USER TOP SKILLS ================= */
  useEffect(() => {
    const fetchTopSkills = async () => {
      try {
        const formBody = new FormData();
        formBody.append("user_id", localStorage.getItem("user_id"));
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}/get_top_skills`,
          data: formBody,
          headers: { "Content-Type": "multipart/form-data" }
        });
        if (response?.data?.result?.data) {
          localStorage.setItem(
            "selectedSkill",
            JSON.stringify(response.data.result.data.selected_skill)
          );
          setUserTopskill(response.data.result.data);
          setIsValueChange(false);
        } else {
          throw new Error("Invalid top skills data format");
        }
      } catch (error) {
        console.error("Failed to fetch top skills", error);
      }
    };
    if (isValueChange) fetchTopSkills();
  }, [isValueChange]);

  /* ================= JOINED COMPANIES ================= */
  useEffect(() => {
    axios
      .post(
        `${config.API_URL()}company/joincompanylist?default_user=${localStorage.getItem(
          "default_user"
        )}`
      )
      .then((res) => {
        if (res?.status === 200) {
          setAllJoinedCompany(res?.data?.user_join_company);
          setLoading(false);
        }
      })
      .catch(() => {});
  }, []);

  /* ================= OWN COMPANIES ================= */
  useEffect(() => {
    axios
      .post(
        `${config.API_URL()}get-own-created-company?user_id=${localStorage.getItem(
          "user_id"
        )}`
      )
      .then((res) => {
        if (res?.data?.status_code === 200) {
          setAllOwnCompany(res?.data?.result?.data?.company_list);
          setLoading(false);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <AllDetailsContext.Provider
      value={{
        userData,
        setUserData,
        companyData,
        setCompanyData,
        userCompanyData,
        setUserCompanyData,
        userSkill,
        userTopskill,
        setIsValueChange,
        setReload,
        fetchUserData, // ✅ EXPOSED HERE
        allOwnCompany,
        allJoinedCompany,
        loading
      }}
    >
      {props.children}
    </AllDetailsContext.Provider>
  );
};

// import React, {useState,createContext,useEffect} from 'react'
// import config from "../../helpers/config";
// import axios from 'axios'

// export const AllDetailsContext = createContext();

// export const UserDetailProvider = (props) => {
// 	const [userData, setUserData] = useState(null)
// 	const [companyData, setCompanyData] = useState(null)
// 	const [userCompanyData, setUserCompanyData] = useState(null)
// 	const [userSkill, setUserSkill] = useState(null)
// 	const [isValueChange, setIsValueChange] = useState(false)
// 	const [reload, setReload] = useState(false)
// 	const [allJoinedCompany, setAllJoinedCompany] = useState(null)
// 	const [loading, setLoading] = useState(null)
// 	const [allOwnCompany, setAllOwnCompany] = useState(null)

// 	useEffect(() => {
//     axios
//       .get(config.API_URL() + "profile"+"/"+localStorage.getItem("user_profile_id")+"?"+"default_user="+localStorage.getItem('default_user'))
//       .then((res) => setUserData(res?.data?.result?.data));
//   }, [reload]);

// 	useEffect(() => {
//     axios
//       .get(config.API_URL() + "recruiters"+"?"+"default_user="+localStorage.getItem('default_user'))
//       .then((res) => setCompanyData(res?.data?.result?.data));
//   }, []);
// 	// http://139.59.35.110/castclass/api/v2/company/list
// 	useEffect(() => {
// 		axios
// 			.get(config.API_URL() + "company" + "/" + "list" + "?" + "default_user=" + localStorage.getItem('default_user'))
// 			.then(res => setUserCompanyData(res?.data?.result?.data))
// 	},[])

// 	useEffect(() => {
//     const formBody = new FormData();
//     formBody.append('user_id', localStorage.getItem('user_id'))
//     axios({
//       method:'post',
//       url:config.API_URL() + 'get_selected_skills',
//       data:formBody,
//       headers: { "Content-Type": "multipart/form-data" },
//     })
//     .then(res => {
//       setUserSkill(res?.data?.result?.data)
//       setIsValueChange(false)
//     })
//     .catch(err => console.log(err))
//   },[isValueChange]);
// 	// console.log(userCompanyData,"this is RESPONSE")

// 	// ?limit=10&offset=0&recruitement_company=0&default_user

// useEffect(() => {
//   axios.post(config.API_URL() + "company/joincompanylist" + "?" + "default_user="
//     + localStorage.getItem('default_user'))
//   .then(res => {
//     // console.log(res,"joincompanylistjoincompanylist alllllllllllll")
//       if(res?.status === 200){
//           setAllJoinedCompany(res?.data?.user_join_company)
//           setLoading(false)
//       }
// })
//   .catch(err => console.log(err))
// },[])

// useEffect(() => {
//   axios.post(`${config.API_URL()}get-own-created-company?user_id=${localStorage.getItem('user_id')}`)
//   .then(res => {
//     // console.log(res,"check for own comp alllllllllllll")
//     if(res?.data?.status_code === 200){
//       setAllOwnCompany(res?.data?.result?.data?.company_list)
//       setLoading(false)

//     }
//   })
// },[])

// 	return(
// 			<AllDetailsContext.Provider value={{
// 				userData,
// 				setUserData,
// 				companyData,
// 				setCompanyData,
// 				userCompanyData,
// 				setUserCompanyData,
// 				userSkill,
// 				setIsValueChange,
// 				setReload,
// 				allOwnCompany,
// 				allJoinedCompany,
// 				loading
// 			}}>
// 				{props.children}
// 			</AllDetailsContext.Provider>
// 		)
// }
